import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import Counter from './components/Counter.vue'

new BlockModule({
    selector: '.block-counter',
    vueComponent: defineComponent({
        components: {
            Counter,
        },
        setup() {},
    }),
})
